<template lang="">
  <div>
    <el-dialog
      :title="$t('field.titleSpecialService')"
      :visible.sync="dialogSpecialServiceVisible"
      :close-on-click-modal="false"
      width="80%"
      @closed="onCloseDialog"
    >
      <!-- <div class="content-container"> -->
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <div class="das-form-group">
              <div>
                <span>Ngày đến: </span><span>{{ firstArrivalDate }}</span
                >, <span>Ngày đi: </span>
                <span>{{ lastDepartureDate }}</span>
              </div>
              <!-- <div class="das-form-row">
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">Mã</div>
                    <input type="text" />
                  </div>
                </div>
                <div class="das-form-col w-33">
                  <div class="das-form-input">
                    <div class="label">Tên</div>
                    <input type="text" />
                  </div>
                </div>
              </div> -->
              <el-row :gutter="10">
                <el-col :span="15" style="height: 400px">
                  <div class="grid-scroll mt-10" style="height: 100%">
                    <GridVx
                      ref="agGridSericeApi"
                      :columns="columnsService2"
                      :rows="rowsService2"
                      class="agGrid"
                      dom-layout="scroll"
                      :auto-size-cell="true"
                      @rowClicked="onClickRowService"
                    />
                    <!--                       @selectionChanged="onSelectSpeSer" -->
                  </div>
                </el-col>
                <el-col :span="9">
                  <!-- <div class="header-form"> -->
                  <!-- <div class="title-form">{{ formService.desc }}</div> -->
                  <validation-observer
                    ref="specialSvFormValidator"
                    rules="required"
                    :name="'Tên dịch vụ'"
                  >
                    <div class="das-form-col">
                      <div class="das-form-input">
                        <div class="label">Tên dịch vụ</div>
                        <input
                          v-model="formService.desc"
                          disabled
                          type="text"
                        />
                      </div>
                    </div>
                    <!-- </div> -->

                    <div
                      class="das-form-row gap"
                      style="flex-wrap: nowrap !important"
                    >
                      <div class="das-form-col">
                        <div class="das-form-input">
                          <div class="label required">
                            {{ $t('field.quantity') }}
                          </div>
                          <validation-provider
                            rules="required|between:1,10000|number"
                            :name="$t('field.quantity')"
                          >
                            <input
                              v-model="formService.quantity"
                              type="number"
                              onkeypress="return  event.charCode >= 48 && event.charCode <= 57"
                            />
                          </validation-provider>
                        </div>
                      </div>
                      <div class="das-form-col">
                        <div class="das-form-input">
                          <div class="label required">
                            {{ $t('field.specialUnitPrice') }}
                          </div>
                          <validation-provider
                            rules="required"
                            :name="$t('field.specialUnitPrice')"
                          >
                            <!-- <input
                              v-model="formService.price"
                              :disabled="!formService.open_fee"
                              type="text"
                              onkeypress="return  event.charCode >= 48 && event.charCode <= 57"
                            /> -->
                            <VxCurrencyInput
                              v-model="formService.price"
                              :disabled-flag="!formService.open_fee"
                            />
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                    <div
                      class="das-form-row gap"
                      style="flex-wrap: nowrap !important"
                    >
                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label required">
                            {{ $t('field.fromDate') }}
                          </div>
                          <validation-provider
                            rules="required"
                            :name="$t('field.fromDate')"
                          >
                            <!-- <SingleCalendar
                              :key="dataKey"
                              v-model="formService.service_start_date"
                              class="use-icon"
                              :date-data="formService.service_start_date"
                              :min-max="{
                                min: firstArrivalDate,
                                max: lastDepartureDate
                              }"
                              @input="changeCalendarStartDate"
                            /> -->
                            <CalendarSelect
                              :key="dataKey"
                              v-model="formService.service_start_date"
                              style="display: block; width: 100%"
                              mode="date"
                              :min-max="{
                                min: firstArrivalDate,
                                max: lastDepartureDate
                              }"
                            />
                          </validation-provider>
                        </div>
                      </div>
                      <div class="das-form-col col-6">
                        <div class="das-form-input">
                          <div class="label required">
                            {{ $t('field.toDate') }}
                          </div>
                          <validation-provider
                            rules="required"
                            :name="$t('field.toDate')"
                          >
                            <CalendarSelect
                              :key="dataKey"
                              v-model="formService.service_end_date"
                              style="display: block; width: 100%"
                              mode="date"
                              :min-max="{
                                min: firstArrivalDate,
                                max: lastDepartureDate
                              }"
                            />
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <div class="das-form-row">
                      <div class="das-form-col col-12">
                        <div class="das-form-input">
                          <div class="label">Ghi chú</div>
                          <textarea v-model="formService.note" :rows="3" />
                        </div>
                      </div>
                    </div>
                    <button
                      class="btn primary small"
                      style="margin-right: 10px"
                      @click="addSpecialService"
                    >
                      Thêm/Sửa
                    </button>
                    <button
                      v-if="canDeleteService"
                      class="btn pink outline small"
                      @click="removeSpecialService"
                    >
                      Xóa
                    </button>
                  </validation-observer>
                </el-col>
              </el-row>
              <div class="grid-scroll mt-10">
                <GridVx
                  ref="agGridTransactionApi"
                  :columns="columnsTransaction"
                  :rows="rowsTransaction"
                  class="agGrid"
                  :auto-size-cell="true"
                  @rowClicked="onClickRowServiceToChange"
                />
              </div>
              <!-- <button class="btn primary small outline" style="margin-top: 5px">
                Hủy
              </button> -->
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <!-- <button class="btn primary small">Tình trạng đáp ứng</button> -->

        <button class="btn primary small" @click="confirmSpecialService">
          Đóng
        </button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import { CellRenderCheckboxReadonly } from '@/utils/groupCellRenders.js'
import { getUserApi } from '@/api/userConfig/user'
import { getSpecialServiceListApi } from '@/api/Service_Policy/specialService'
// import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'

export default {
  components: {
    // CellRenderCheckboxReadonly
    // CalendarRange,
    CalendarSelect
  },
  props: {
    specialServices: {
      type: Array,
      default: () => {
        return []
      }
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    firstArrivalDate: {
      type: String,
      default: null
    },
    lastDepartureDate: {
      type: String,
      default: null
    },
    bookingRoom: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      addFlag: null,
      addFlagDefault: null,
      dialogSpecialServiceVisible: false,
      accountOptions: [],
      dataKey: 0,

      columnsAccount: [
        {
          headerName: 'ID Nhân viên',
          field: 'id_card',
          width: 100
        },
        {
          headerName: 'Họ và tên',
          field: 'full_name'
        }
      ],
      columnsService2: [
        {
          headerName: 'Mã dịch vụ',
          headerTooltip: 'Mã dịch vụ',
          field: 'code',
          tooltipField: 'code',
          cellStyle: params => {
            // if(params.value === 0) return {}
          }
        },
        {
          headerName: 'Dịch vụ đặc biệt',
          headerTooltip: 'Dịch vụ đặc biệt',
          field: 'desc',
          tooltipField: 'desc'
        },
        {
          headerName: 'Giá đơn vị',
          headerTooltip: 'Giá đơn vị',
          field: 'fee',
          // tooltipField: 'fee',
          cellRenderer: params => {
            return params.value !== null
              ? parseInt(params.value).toLocaleString('en-US')
              : null
          },
          tooltipValueGetter: params => {
            return params.value !== null
              ? parseInt(params.value).toLocaleString('en-US')
              : null
          },
          cellClass: 'grid-cell-right'
        },
        {
          headerName: 'Mở',
          field: 'open_price',
          cellRenderer: 'CellRenderCheckboxReadonly',
          tooltipField: 'open_price',
          cellClass: 'grid-cell-align-center'
        },
        {
          headerName: 'Tiền tệ',
          field: 'currency_code',
          tooltipField: 'currency_code'
        },
        {
          headerName: 'Bao gồm trong tiền phòng',
          headerTooltip: 'Bao gồm trong tiền phòng',
          field: 'separate_room_fee',
          tooltipField: 'separate_room_fee',
          cellRenderer: 'CellRenderCheckboxReadonly',
          cellClass: 'grid-cell-align-center'
        }
      ],
      rowsService2: [],
      // form special service
      defaultFormService: {
        id: null,
        code: '',
        desc: '',
        quantity: 1,
        note: '',
        currency: '',
        price: null,
        open_fee: false,
        special_service_id: null,
        booking_group_id: null,
        service_start_date: this.firstArrivalDate,
        service_end_date: this.lastDepartureDate,
        employee_id: null,
        employee_name: null
      },
      formService: {
        id: null,
        code: '',
        desc: '',
        quantity: 1,
        note: '',
        currency: '',
        price: null,
        open_fee: false,
        special_service_id: null,
        booking_group_id: null,
        service_start_date: this.firstArrivalDate,
        service_end_date: this.lastDepartureDate,
        employee_id: null,
        employee_name: null
      },
      columnsTransaction: [
        {
          headerName: 'Mã',
          minWidth: 100,
          field: 'code',
          tooltipField: 'phone_number'
        },
        {
          headerName: 'Tên',
          minWidth: 100,
          field: 'desc',
          tooltipField: 'desc'
        },
        {
          headerName: 'Giá đơn vị',
          headerTooltip: 'Giá đơn vị',
          minWidth: 100,
          field: 'price',
          // tooltipField: 'price',
          cellRenderer: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          tooltipValueGetter: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          cellClass: 'grid-cell-right'
        },
        {
          headerName: 'Số lượng',
          minWidth: 100,
          field: 'quantity',
          tooltipField: 'quantity'
        },
        {
          headerName: 'Từ ngày',
          minWidth: 100,
          field: 'service_start_date',
          tooltipField: 'service_start_date'
        },
        {
          headerName: 'Đến ngày',
          minWidth: 100,
          field: 'service_end_date',
          tooltipField: 'service_end_date'
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note'
        }
      ],
      rowsTransaction: [],
      formServiceTmpList: [] // / for form.special_services before confirm
    }
  },
  computed: {
    rangeDate: {
      get() {
        return {
          start: this.formService.service_start_date,
          end: this.formService.service_end_date
        }
      },
      set(val) {
        this.formService.service_start_date = val.start
        this.formService.service_end_date = val.end
      }
    },
    canDeleteService() {
      return (
        // (this.bookingRoom?.booking_room_status == null ||
        //   this.bookingRoom?.booking_room_status === 1) &&
        this.rowsTransaction.length > 0 &&
        this.formService.id !== null &&
        this.formService.id <= this.addFlag
      )
    }
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val) {
        this.dialogSpecialServiceVisible = this.dialogVisible
      }
    },
    specialServices() {
      this.addFlag = this.rowsTransaction.length
      this.addFlagDefault = this.rowsTransaction.length
      this.rowsTransaction = this.specialServices
    }
  },
  mounted() {
    this.getSpecialService()
    this.getListAccount()
  },
  methods: {
    async getListAccount() {
      const data = await getUserApi({ is_active: true })

      const rowData = data.data.map(item => item.account)
      this.accountOptions = [...rowData]
      // this.accountOptions = data.data.map(item => item?.account)
    },
    onSelectEmployee_Service(val) {
      this.formService.employee_id = val.id
      this.formService.employee_name = val.full_name
    },
    onCloseDialog() {
      this.$emit('closeDialog')
    },
    async getSpecialService() {
      const data = await getSpecialServiceListApi({
        page_size: 100,
        page_num: 1,
        order_tp: 'ASC'
      })
      this.rowsService2 = [...data.data]
    },
    onClickRowService(row) {
      this.addFlag =
        this.rowsTransaction.slice(-1)?.id ?? this.rowsTransaction.length
      this.addFlag += 1

      this.dataKey++
      this.formService.id = this.addFlag + 1
      this.formService.special_service_id = row[0].id
      this.formService.desc = row[0].desc
      this.formService.price = parseInt(row[0].fee)
      this.formService.code = row[0].code
      this.formService.open_fee = row[0].open_price
      this.formService.currency = row[0].currency_code
      // console.log(this.formService)
    },
    onClickRowServiceToChange(row) {
      // console.log(row[0])
      this.dataKey++
      this.formService.id = row[0].id
      this.formService.special_service_id = row[0].special_service_id
      this.formService.desc = row[0].desc
      this.formService.price = row[0].price
      this.formService.code = row[0].code
      this.formService.open_fee = row[0].open_fee
      this.formService.currency = row[0].currency
      this.formService.service_start_date = row[0].service_start_date
      this.formService.service_end_date = row[0].service_end_date
      this.formService.note = row[0].note
      this.formService.employee_id = row[0].employee_id
      this.formService.employee_name = row[0].employee_name
      this.formService.quantity = row[0].quantity
    },
    async addSpecialService() {
      if (
        (await this.$vxForm.isValid(this.$refs.specialSvFormValidator)) ===
        false
      ) {
        return
      }
      if (
        this.$moment(this.formService.service_start_date).isAfter(
          this.formService.service_end_date
        )
      ) {
        this.$message({
          type: 'error',
          message: 'Ngày cuối không trước ngày đầu'
        })
        return
      }
      const index = this.rowsTransaction.findIndex(
        item => item.id === this.formService.id
      )
      if (index !== -1) {
        this.rowsTransaction[index] = this.formService
        // this.$refs.agGridTransactionApi.gridOptions.api.refreshCells({
        //   force: true
        // })

        this.$refs.agGridTransactionApi.gridOptions.api.forEachNode(node => {
          if (node.data.id === this.formService.id) {
            node.setData(this.formService)
          }
        })
      } else this.rowsTransaction.push(this.formService)
      // this.form.special_services.push(this.formService)
      this.addFlag++
      this.formService = { ...this.defaultFormService }
    },
    removeSpecialService() {
      const index = this.rowsTransaction.findIndex(
        item => item.id === this.formService.id
      )
      this.rowsTransaction.splice(index, 1)
    },
    confirmSpecialService() {
      this.$emit('confirmSpecialService', this.rowsTransaction)
      this.onCloseDialog()
    },

    changeCalendarStartDate(value) {
      // const date = this.$moment(value).format('YYYY-MM-DD')
      this.formService.service_start_date = value
    },
    changeCalendarEndDate(value) {
      // const date = this.$moment(value).format('YYYY-MM-DD')
      this.formService.service_end_date = value
    }
  }
}
</script>
<style lang=""></style>
